module.exports = __webpack_public_path__ + "img/icon-image.b54adeb4.svg";